import { GridModel, GridPostParams } from "common/models/utility-models/list-utility.model";
import { AssignmentModel } from "./assignment-data.model";

export class AssignmentGridModel extends AssignmentModel { }

export class AssignmentListingModel extends GridModel<AssignmentGridModel> { }

export class AssignmnetGridParams extends GridPostParams {
    pageNumber: number = 1;
    pageSize: 10;
    search_keyword: any = '';
    region_search: any = '';
    batch_search: any = '';
    location_search: any = '';
    type_search: any = '';
    status_text: any = '';
    column: any = '';
    direction: any = '';
  }